module.exports = __webpack_public_path__ + "static/media/404-500-bg-2.f51d93f4.jpg";